<template>
  <div :id="uid" class="feature-block text-center">
    <div class="rounded-background center-block">
      <div class="icon-container" v-if="icon">
        <svg-icon :icon="icon" color="#fff"/>
      </div>
      <div v-else-if="image" class="img-container">
        <img :src="require(`@/assets/img/${image}`)">
      </div>
    </div>
    <h4><span v-html="title"></span></h4>
    <h5><span v-html="subtitle"></span></h5>
    <tooltip :text="text"
           :target="'#' + uid"
           placement="bottom"/>
  </div>
</template>
<script>
import svgIcon from '@/sui/components/svgIcon'

export default {
  name: 'feature-block',
  props: {
    title: {
      type: String,
      required: true
    },

    subtitle: {
      type: String,
      default: ''
    },

    icon: {
      type: String
    },

    text: {
      type: String
    },

    image: {
      type: String
    }
  },

  computed: {
    uid: function () {
      return 'feature-block-' + this._uid
    }
  },

  components: {
    'svg-icon': svgIcon
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.rounded-background {
  position: relative;
  width: 80%;
  padding-top: 80%;
  height: 0;
  background-color: @base;
  border-radius: 50%;
  display: block;
}

.icon-container {
  position: absolute;
  top: 20%;
  left: 20%;
  bottom: 20%;
  right: 20%;
}

.img-container {
  position: absolute;
  top: 20%;
  left: 12%;
  bottom: 20%;
  right: 12%;
  display: flex;
  align-items: center;

  img {
    width: 100%;
  }
}
</style>
